<template>
    <section>
        <h2 class="h2Title">메일 발송</h2>
        <div class="tabs">
            <ul class="tabMenu">
                <li class="tabList" v-for="(tab, idx) in tabs" v-bind:class="{active: currentTab === idx}" :key="idx">
                    <button type="button" class="tabsTit" v-on:click="currentTab = idx">{{tab}}</button>
                </li>
            </ul> 
        </div>
        <div class="tabContentBx">
            <div v-show="currentTab === 0" class="tabContent">
                <MailSend />
            </div>
            <div v-show="currentTab === 1" class="tabContent">
                <MailHistory />
            </div>
        </div>
    </section>
</template>

<script>
    import MailSend from "./MailSend";
    import MailHistory from "./MailHistory";
    export default {
        name: "Mail",
        components: {MailHistory, MailSend},
        data: () => ({
            currentTab: 0,
            tabs: ['메일 발송', '메일 발송 내역'],
        }),
        watch: {
          ProductsearchDialog: false
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/style/layout/variables';

    .h2Title {
        @include h2-title;
    }
    .tabMenu {
        display: flex;
        border-bottom: 1px solid $point-color;
        margin-bottom: 20px;

        .tabList {
            display: flex;
            align-items: center;
            position: relative;
            height: 47px;
            border-top: 1px solid $gary-color;
            border-right: 1px solid $gary-color;

            &:first-child {
                border-left: 1px solid $gary-color;
            }

            &.active {
                border-top: 1px solid $point-color;
                border-left: 1px solid $point-color;
                border-right: 1px solid $point-color;
                border-bottom: 1px solid $white-color;

                &::before, &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    width: 100%;
                }

                &::before {
                    top: 0;
                    border-top: 3px solid $point-color;
                }

                &::after {
                    bottom: -2px;
                    border-top: 1px solid $white-color;
                }
            }

            .tabsTit {
                position: relative;
                top: 3px;
                height: 100%;
                padding: 0 40px;
            }
        }
    }

</style>